export default {
    getSiteCurrency(state) {
        return state.site.currency
    }
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/getters/siteGetters.js